<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-breadcrumbs class="pl-0 ml-0" :items="breadcrumbs" divider=">">
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <h1>Your linkedin account</h1>
      </v-col>
      <v-col cols="12">
        <p>
          We need your linkedin account to verify your experience from previous
          step match your linkedin profile.
          <b>
            We will not share your linkedin account on your public reviewer
            profile.</b
          >
        </p>
      </v-col>
      <v-col cols="6" v-if="initialLoading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>
      <v-col cols="6" v-if="!initialLoading && !editUrl">
        <p>Your current linkedin profile:</p>
        <v-chip close close-icon="mdi-pencil" @click:close="editUrl = true">{{
          linkedinUrl
        }}</v-chip>
      </v-col>
      <v-col cols="6" v-if="editUrl">
        <v-text-field
          label="Link to your linkedin account"
          :rules="linkRules"
          hide-details="auto"
          @change="linkChanged"
          v-model="linkedinUrl"
          :disabled="initialLoading"
          ref="linkedinTextField"
          :loading="initialLoading"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2" v-if="editUrl">
        <v-btn
          color="primary"
          :disabled="initialLoading || saveUrlLoading"
          :loading="saveUrlLoading"
          @click="setLinkedinUrl()"
          >save</v-btn
        >
      </v-col>
      <v-col cols="6" v-if="errorMsg != ''">
        <v-alert dense outlined text type="error" class="ma-0">{{
          errorMsg
        }}</v-alert>
      </v-col>
      <v-col cols="12" class="d-flex">
        <v-spacer></v-spacer>
        <v-form>
          <v-btn
            color="primary"
            class="mr-2 mb-3"
            to="/reviewer-enrollment/step3?chained=true"
            v-if="chained"
            :disabled="initialLoading || saveUrlLoading"
          >
            Next step - setup your payments
          </v-btn>
          <v-btn
            color="primary"
            class="mr-2 mb-3"
            to="/settings"
            v-if="!chained"
          >
            Done - back to settings
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
</style>

<script>
export default {
  data() {
    return {
      chained: false,
      initialLoading: true,
      saveUrlLoading: false,
      editUrl: false,
      linkedinUrl: "",
      linkRules: [
        (value) => {
          if (value == null) return "URL is required";
          const linkedinRegex =
            /^https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9-]+(\/)?$/;
          if (linkedinRegex.test(value) == false)
            return "Invalid linkedin url, expected format: https://www.linkedin.com/in/abcd";
          return true;
        },
      ],
      breadcrumbs: [
        {
          text: "Settings",
          disabled: false,
          href: "/settings",
        },
        {
          text: "Reviewer enrollment - linkedin account",
          disabled: true,
          href: "/reviewer-enrollment/step2",
        },
      ],
      linkedinUrlValid: false,
      errorMsg: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    console.log(this.$route.query.chained);
    if (this.$route.query.chained == "true") {
      this.chained = true;
    }
    this.getLinkedinUrl();
  },
  methods: {
    async linkChanged(url) {
      console.log(this.linkedinUrl);
      var newStr = this.linkedinUrl.toLowerCase();
      if (newStr.startsWith("http://")) {
        newStr = newStr.replace(/^http?:\/\//, "https://");
      } else if (!newStr.startsWith("https://")) {
        newStr = "https://" + newStr;
      }
      this.linkedinUrl = newStr;
      this.validateLinkedinUrl();
      return;
    },
    getLinkedinUrl() {
      // getting linkedin url
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/api/getLinkedinUrl",
          {
            dusi: this.$store.getters.getDusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.linkedinUrl != "") {
              this.linkedinUrl = response.data.linkedinUrl;
              this.editUrl = false;
            } else {
              this.editUrl = true;
            }
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
        })
        .finally(() => {
          this.validateLinkedinUrl();
          this.initialLoading = false;
        });
    },
    async setLinkedinUrl() {
      this.saveUrlLoading = true;
      this.validateLinkedinUrl();
      if (!this.linkedinUrlValid) {
        this.errorMsg = "Invalid linkedin url";
        this.saveUrlLoading = false;
        return;
      }
      this.showLoading = true;
      const dusi = this.$store.getters.getDusi;
      await this.$http
        .post(
          this.$consts.BE_ADDRESS + "/api/setLinkedinUrl",
          {
            linkedinUrl: this.linkedinUrl,
            dusi: dusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (response.status != 200) {
            if (response.data.error) {
              throw new Error(response.data.error);
            }
            throw new Error("Unknown error from server");
          }
        })
        .catch((error) => {
          this.errorMsg = this.$utils.getErrorMsg(error);
        })
        .finally(() => {
          this.saveUrlLoading = false;
          this.editUrl = false;
        });
    },
    validateLinkedinUrl() {
      if (this.$refs?.linkedinTextField) {
        this.linkedinUrlValid = this.$refs.linkedinTextField.validate();
      }
    },
  },
};
</script>
